import getStyles from "./styles";
import MainContainer from "../MainContainer";
import { formatTime } from "../../functions";
import { ISRAELIID_LENGTHS, REGISTRATION_NUMBER_LENGTHS } from "../../constants";
import { useAppDispatch, useAppSelector } from "../../redux";
import { searchUserByIsraeliIdAction, searchUserByRegNumAction, selectSearchedUser } from "../Dashboard/DashboardSlice";
import { useEffect, useState, type ChangeEvent, type FormEvent } from "react";
import { Search } from "@mui/icons-material";
import {
  Box,
  Paper,
  Table,
  Button,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TextField,
  TableContainer,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";

export default function _CallCenterPanel() {
  const styles = getStyles();
  const text = useAppSelector(selectText);

  const dispatch = useAppDispatch();

  const searchedUser = useAppSelector(selectSearchedUser);

  const [searchOption, setSearchOption] = useState<"israeliId" | "regNum" | null>("regNum");
  const [registrationNumber, setRegistrationNumber] = useState<number | null>(null);
  const [israeliId, setIsraeliId] = useState<string | null>(null);
  const [disable, setDisable] = useState<boolean>(true);

  const [errors, setErrors] = useState({
    registrationNumber: false,
    israeliId: false,
  });

  useEffect(() => {
    if (searchOption === "regNum") {
      setDisable(!REGISTRATION_NUMBER_LENGTHS.includes(String(registrationNumber).length));
    }
    if (searchOption === "israeliId") {
      setDisable(!ISRAELIID_LENGTHS.includes(String(israeliId).length));
    }
  }, [searchOption, registrationNumber, israeliId]);

  const handleValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    if (searchOption === "regNum") {
      if (!value || isNaN(Number(value))) return setRegistrationNumber(null);
      setRegistrationNumber(Number(value));
    }
    if (searchOption === "israeliId") {
      if (!value || isNaN(Number(value))) return setIsraeliId(null);
      setIsraeliId(value);
    }
  };

  const handleSearchUser = async (event: FormEvent) => {
    event.preventDefault();
    if (searchOption === "regNum") {
      await dispatch(searchUserByRegNumAction(String(registrationNumber)));
    }
    if (searchOption === "israeliId") {
      if (!israeliId) return;
      await dispatch(searchUserByIsraeliIdAction(israeliId));
    }
  };

  const handleSearchOptionChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchOption(event.target.value as "israeliId" | "regNum");
    setErrors({
      registrationNumber: false,
      israeliId: false,
    });
  };

  return (
    <MainContainer avatar={<Search />} title="PANEEM status search" titleVariant="h4">
      <Box component="form" onSubmit={handleSearchUser} autoComplete="off" sx={styles.root}>
        <Typography variant="h6" align="center" gutterBottom>
          {text.chooseLoginOption}
        </Typography>
        <RadioGroup
          row
          value={searchOption}
          onChange={handleSearchOptionChange}
          sx={{ justifyContent: "center", marginBottom: "1rem" }}
        >
          <FormControlLabel value="israeliId" control={<Radio />} label={text.israeliId} />
          <FormControlLabel value="regNum" control={<Radio />} label={text.regNum} />
        </RadioGroup>
        {searchOption === "israeliId" && (
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="Israeli ID"
            name="israeli_id"
            value={israeliId ? israeliId : ""}
            onChange={handleValueChange}
            autoFocus
            inputProps={{ maxLength: 9 }}
            type="tel"
          />
        )}
        {searchOption === "regNum" && (
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="Registration Number"
            name="registrationNumber"
            value={registrationNumber ? registrationNumber : ""}
            onChange={handleValueChange}
            autoFocus
            inputProps={{ maxLength: 7 }}
            type="tel"
          />
        )}

        <Button type="submit" fullWidth variant="contained" color="primary" disabled={disable}>
          Search
        </Button>

        {!searchedUser ? null : (
          <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Registration Number</TableCell>

                  <TableCell align="center">Birth Date</TableCell>

                  <TableCell align="center">Status</TableCell>

                  <TableCell align="center">A2 reason</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableCell align="center">{searchedUser.registrationNumber}</TableCell>

                <TableCell align="center">{formatTime(searchedUser.birthDate)}</TableCell>

                <TableCell align="center">{searchedUser.status}</TableCell>

                <TableCell align="center">{searchedUser.A2Reason ? searchedUser.A2Reason : null}</TableCell>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </MainContainer>
  );
}
